import { dateFormat, useForceUpdate } from "../../../services/misc.functions";
import { bulletinProvider } from "../../../services/bulletin.service";
import {
  betSlipActionSubject,
  bettingTab,
  bettingTabSubject,
  clearTjkBetSlipOptions,
  mobileBetSlipActions,
  mobileBetSlipSubject,
  tjkBetSlipOptions,
} from "../../../services/betslip.service";
import {availableFobHippodromes, fobBettingTypesIds} from "../../../store/bulletin.store";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import paths from "../../../paths";
import { isMobile } from "../../../App";
import redHorse from "../../../assets/img/kirmiziat.png";

export function FobBettingTypeOptions(props: any) {
  const params = props.params;
  const forceUpdate = useForceUpdate();
  const navigate = useNavigate();
  let hippodrome: any = props.hippodrome;

  let availableFobBettingTypes: any = null;
  // let availableFobBettingTypes: any = bulletinProvider.getAvailableFobBettingTypes(hippodrome);

  if (hippodrome === "all") {
    availableFobBettingTypes = bulletinProvider.getAvailableFobBettingTypes(availableFobHippodromes[0]);
  } else {
    availableFobBettingTypes = bulletinProvider.getAvailableFobBettingTypes(hippodrome);
  }
  const [showFixedOdd, setShowFixedOdd] = useState<boolean>(false);

  const selectBettingType = props.selectBettingType;
  const selectBettingSubType = props.selectBettingSubType;

  useEffect(() => {
    hippodrome = props.hippodrome;
  }, [props.hippodrome]);

  useEffect(() => {
    let betSlipActionSubject_subscription = betSlipActionSubject.subscribe((res: any) => {
      forceUpdate();
    });
    return () => {
      betSlipActionSubject_subscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    let isExistFob = availableFobBettingTypes.find((b: any) => fobBettingTypesIds.includes(b.id));
    if (isExistFob !== undefined) {
      setShowFixedOdd(true);
    } else {
      setShowFixedOdd(false);
    }
  }, [availableFobBettingTypes, hippodrome]);

  if (mobileBetSlipActions.isOpen) {
    return <></>;
  }

  return (
    <div className="bettingtype-options px-4 py-2 p-sm-3 pb-sm-4 mb-2">
      {isMobile ? (
        <>
          <div className={"row"}>
            <div className={"col-6 pe-0 ps-0"}>
              <label className="hidden-sm">HİPODROMLAR</label>
              <select
                onChange={(e: any) => {
                  if (e.target.value !== "all") {
                    clearTjkBetSlipOptions();
                    navigate(`${paths.fobBetting.url}/${e.target.value.toLowerCase()}`);
                  } else {
                    navigate(`${paths.fobBetting.url}`);
                  }
                }}
                value={
                  hippodrome === "all" ? "all" : tjkBetSlipOptions.hippodrome.keyword + tjkBetSlipOptions.hippodrome._id
                }
              >
                <option key={`keyHippodrome-hepsi`} value={"all"}>
                  Hepsi
                </option>
                {availableFobHippodromes.map((_hippodrome: any, keyHippodrome: number) => {
                  if (_hippodrome.wager_details.length > 0) {
                    return (
                      <option key={`keyHippodrome-${keyHippodrome}`} value={_hippodrome.keyword + _hippodrome._id}>
                        {_hippodrome.hippodrome}
                        {new Date(_hippodrome.date).getDate() <= new Date().getDate() ? (
                          <>{_hippodrome.nextRun && ` - ${_hippodrome.nextRun.no}. Koşu ${_hippodrome.nextRun.time}`}</>
                        ) : (
                          <> - ({dateFormat(_hippodrome.date)})</>
                        )}
                      </option>
                    );
                  }
                })}
              </select>
            </div>
            {tjkBetSlipOptions.bettingType && tjkBetSlipOptions.bettingType.id !== 0 && (
              <div className="col-6 pe-0 ps-2">
                <label className="hidden-sm">BAHİS TÜRÜ</label>
                <select
                  onChange={(e: any) => {
                    selectBettingType(e.target.value);
                    tjkBetSlipOptions.complete = false;
                    betSlipActionSubject.next(true);
                  }}
                  value={tjkBetSlipOptions.bettingType.id}
                >
                  {availableFobBettingTypes.map((bettingType: any, keyBettingType: number) => {
                    return (
                      <option key={`keyBettingType-${keyBettingType}`} value={bettingType.id}>
                        {bettingType.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            )}
            {/*{tjkBetSlipOptions.bettingSubType && tjkBetSlipOptions.bettingType.id !== 0 && (
                            <div className="col-4 pe-0 ps-2">
                                <label className="hidden-sm"></label>
                                <select
                                    onChange={(e: any) => {
                                        selectBettingSubType(e.target.value);
                                    }}
                                    value={tjkBetSlipOptions.bettingSubType.id}
                                >
                                    {availableBettingSubTypes.map((bettingSubType: any, keyBettingSubType: number) => {
                                        return (
                                            <option key={`keyBettingType-${keyBettingSubType}`}
                                                    value={bettingSubType.id}>
                                                {bettingSubType.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        )}*/}
          </div>
          <div className="row mt-2">
            <div className="col-4  pe-0 ps-0">
              <Link
                to={`${paths.fobBetting.url}/${tjkBetSlipOptions.hippodrome?.keyword.toLowerCase()}${
                  tjkBetSlipOptions.hippodrome?._id
                }`}
                onClick={() => {
                  // setMobileBetslip(false)
                  bettingTab.title = "";
                  bettingTabSubject.next("update");
                  mobileBetSlipActions.isOpen = false;
                  mobileBetSlipSubject.next("update");
                }}
                className={`btn btn-muhtemeller ${!params.subpage ? "active" : ""}`}
              >
                BAHİS YAP
              </Link>
            </div>

            <div className="col-4 pe-0 ps-2">
              <Link
                to={`${paths.betting.url}/${tjkBetSlipOptions.hippodrome?.keyword.toLowerCase()}${
                  tjkBetSlipOptions.hippodrome?._id
                }/muhtemeller`}
                className={`btn btn-muhtemeller ${params.subpage === "muhtemeller" ? "active" : ""}`}
                onClick={() => {
                  bettingTab.title = "MUHTEMELLER";
                  bettingTabSubject.next("update");
                }}
              >
                MUHTEMEL/AGF
              </Link>
            </div>
            <div className="col-4 pe-0 ps-2">
              <Link className={`btn btn-tab-agf fob-switch active`} to={`${paths.betting.url}`}>
                <img alt={"iconFather"} src={redHorse} className={"me-1"} height={30} />
                MÜŞTEREK BÜLTEN
              </Link>
            </div>
          </div>
        </>
      ) : (
        <div className="row">
          <div className="col-12 mb-2 mb-sm-0 col-lg-3 p-0 px-sm-2">
            <label className="hidden-sm">HİPODROMLAR</label>
            <select
              onChange={(e: any) => {
                if (e.target.value !== "all") {
                  clearTjkBetSlipOptions();
                  navigate(`${paths.fobBetting.url}/${e.target.value.toLowerCase()}`);
                } else {
                  navigate(`${paths.fobBetting.url}`);
                }
              }}
              value={
                hippodrome === "all" ? "all" : tjkBetSlipOptions.hippodrome.keyword + tjkBetSlipOptions.hippodrome._id
              }
            >
              <option key={`keyHippodrome-hepsi`} value={"all"}>
                Hepsi
              </option>
              {availableFobHippodromes.map((_hippodrome: any, keyHippodrome: number) => {
                if (_hippodrome.wager_details.length > 0) {
                  return (
                    <option key={`keyHippodrome-${keyHippodrome}`} value={_hippodrome.keyword + _hippodrome._id}>
                      {_hippodrome.hippodrome}
                      {new Date(_hippodrome.date).getDate() <= new Date().getDate() ? (
                        <>{_hippodrome.nextRun && ` - ${_hippodrome.nextRun.no}. Koşu ${_hippodrome.nextRun.time}`}</>
                      ) : (
                        <> - ({dateFormat(_hippodrome.date)})</>
                      )}
                    </option>
                  );
                }
              })}
            </select>
          </div>
          <div className="col-6 col-lg-2 p-0 pe-1 pe-sm-2">
            {tjkBetSlipOptions.bettingType && tjkBetSlipOptions.bettingType.id !== 0 && (
              <>
                <label className="hidden-sm">BAHİS TÜRÜ</label>
                <select
                  onChange={(e: any) => {
                    selectBettingType(e.target.value);
                    tjkBetSlipOptions.complete = false;
                    betSlipActionSubject.next(true);
                  }}
                  value={tjkBetSlipOptions.bettingType.id}
                >
                  {availableFobBettingTypes.map((bettingType: any, keyBettingType: number) => {
                    return (
                      <option key={`keyBettingType-${keyBettingType}`} value={bettingType.id}>
                        {bettingType.name}
                      </option>
                    );
                  })}
                </select>
              </>
            )}
          </div>
          {/* <div className="col-6 col-lg-2 p-0 ps-1 pe-sm-2">
                        {tjkBetSlipOptions.bettingSubType && tjkBetSlipOptions.bettingType.id !== 0 && (
                            <>
                                <label className="hidden-sm">KOŞU</label>
                                <select
                                    onChange={(e: any) => {
                                        selectBettingSubType(e.target.value);
                                    }}
                                    value={tjkBetSlipOptions.bettingSubType.id}
                                >
                                    {availableBettingSubTypes.map((bettingSubType: any, keyBettingSubType: number) => {
                                        return (
                                            <option key={`keyBettingType-${keyBettingSubType}`}
                                                    value={bettingSubType.id}>
                                                {bettingSubType.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </>
                        )}
                    </div> */}

          <div className="col-lg-7 p-0 px-sm-2 pt-2 pt-sm-4">
            <div className="row justify-content-end">
              <div className={`col-3 col-lg-2 pe-1 ps-1`}>
                <Link
                  to={`${paths.fobBetting.url}/${tjkBetSlipOptions.hippodrome?.keyword.toLowerCase()}${
                    tjkBetSlipOptions.hippodrome?._id
                  }`}
                  onClick={() => {
                    // setMobileBetslip(false)
                    bettingTab.title = "";
                    bettingTabSubject.next("update");
                    mobileBetSlipActions.isOpen = false;
                    mobileBetSlipSubject.next("update");
                  }}
                  className={`btn btn-muhtemeller ${!params.subpage ? "active" : ""}`}
                >
                  BAHİS YAP
                </Link>
              </div>
              <div className="col-2 pe-1 ps-1">
                <Link
                  to={`${paths.betting.url}/${tjkBetSlipOptions.hippodrome.keyword.toLowerCase()}${
                    tjkBetSlipOptions.hippodrome._id
                  }/muhtemeller`}
                  className={`btn btn-muhtemeller ${params.subpage === "muhtemeller" ? "active" : ""}`}
                  onClick={() => {
                    bettingTab.title = "MUHTEMELLER";
                    bettingTabSubject.next("update");
                  }}
                >
                  MUHTEMELLER
                </Link>
              </div>
              <div className="col-2 pe-1 ps-1">
                <Link
                  to={`${paths.betting.url}/${tjkBetSlipOptions.hippodrome.keyword.toLowerCase()}${
                    tjkBetSlipOptions.hippodrome._id
                  }/agf`}
                  className={`btn btn-agf ${params.subpage === "agf" ? "active" : ""}`}
                  onClick={() => {
                    bettingTab.title = "AGF";
                    bettingTabSubject.next("update");
                  }}
                >
                  AGF
                </Link>
              </div>
              {/* <div className={`col-3 col-lg-3 pe-1 ps-1`}>
                <button
                  className={`btn btn-agf ${params.subpage === "agf" ? "active" : ""}`}
                  onClick={() => {
                    props.setSmartView((prevSmartView: any) => !prevSmartView);
                  }}
                >
                  {props.smartView ? "Standart Görünüm" : `Canlı Görünüm`}
                </button>
              </div> */}

              <div className="col-3 col-lg-3  ps-1">
                <Link
                  className={`btn btn-agf`}
                  style={{ fontSize: "12px", lineHeight: "1.2" }}
                  to={`${paths.betting.url}`}
                >
                  <img alt={"iconFather"} src={redHorse} className={"me-1"} height={30} />
                  MÜŞTEREK BÜLTEN
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
